
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 87.72 87.95"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Livello 2","fill":"none","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"4.95"}},[_c('ellipse',{attrs:{"cx":"31.24","cy":"66.73","rx":"26.26","ry":"11.47"}}),_c('ellipse',{attrs:{"cx":"57.5","cy":"18.17","rx":"26.26","ry":"11.47"}}),_c('path',{attrs:{"stroke-linecap":"round","d":"M31.24 66.73L57.5 18.17"}})])])
          )
        }
      }
    